<template>
  <div class="height-full">
    <tk-flex :gutter="10" class="m-b-10">
      <div>
        <LevleSelect v-model="level" />
      </div>
      <div>
        <a-select
          show-search
          v-model="name"
          placeholder="搜索名称"
          :filter-option="false"
          :show-arrow="true"
          :default-active-first-option="false"
          :not-found-content="null"
          @search="onSearch"
          @select="onSelect"
          @focus="onFocus"
          style="width: 200px"
        >
          <a-select-option v-for="item in searchOptions" :key="item.objectId" :value="item.objectId">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="fill"></div>
      <div>
        <a-button
          type="primary"
          @click="addData"
          v-if="can('createGrainWarehouseModel')"
        >
          新建
        </a-button>
      </div>
    </tk-flex>
    <div class="height-full">
      <tk-flex class="height-full" center middle v-if="isEmpty">
        <a-empty />
      </tk-flex>
      <div class="width-full height-full" v-else>
        <div class="min-heiget-90">
          <a-row :gutter="[16, 16]" type="flex">
            <a-col
              v-for="item in datas"
              :key="item.objectId"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              :xxl="8"
            >
              <WaredepotCard
                :warehouse="item"
                @edit="reset"
                @delete="reset"
                @click="jump(item)"
              />
            </a-col>
          </a-row>
        </div>
        <tk-flex class="m-t-20" right>
          <a-pagination
            show-quick-jumper
            v-model="current"
            :pageSize.sync="pageSize"
            :pageSizeOptions="['9', '12', '15', '18']"
            showSizeChanger
            :total="total"
            @change="onChange"
            @showSizeChange="onShowSizeChange"
          />
        </tk-flex>
      </div>
    </div>
    <a-modal
    :maskClosable="false"
      title="新增粮库"
      :visible="showAdd"
      :confirm-loading="confirmAddLoading"
      @ok="handleAddOk"
      destroyOnClose
      @cancel="handleAddCancel"
    >
      <ak-inputs v-model="formdata" :options="options" ref="inputs" />
    </a-modal>
  </div>
</template>
<script>
import { notEmpty, isPhone } from '../../utils/validator'
import { mapGetters } from 'vuex'
import WaredepotCard from '../../components/waredepot/card'
import LevleSelect from '../../components/levleSelect'
import moment from 'moment'
import { getAddressAllAdcode } from '../../utils/adcode.js'
export default {
  components: {
    WaredepotCard,
    LevleSelect
  },
  data () {
    return {
      // add modal
      options: [
        {
          name: 'hierarchy',
          note: '所属层级',
          type: 'Pointer',
          validators: [notEmpty()],
          span: 24,
          targetClass: 'hierarchy',
          searchKey: ['name'],
          listWhere: where => {
            where.tag = {
              $regex: `^${this.userLevelTag}`
            }
          }
        },
        {
          name: 'name',
          note: '粮库名称',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'wheelMan',
          note: '负责人',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'wheelManPhone',
          note: '负责人电话',
          type: 'String',
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'contacter',
          note: '联系人',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'contacterPhone',
          note: '联系人电话',
          type: 'String',
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'address',
          note: '地址',
          type: 'Region',
          validators: [notEmpty()]
        },
        {
          name: 'detailedAddress',
          note: '详细地址',
          type: 'String',
          validators: [notEmpty()]
        }
      ],
      showAdd: false,
      confirmAddLoading: false,
      formdata: {},
      // list + page
      datas: [],
      total: 0,
      pageSize: 9,
      current: 1,
      // filter
      name: null,
      level: undefined,
      rangeValue: [],
      searchOptions: []
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    isEmpty () {
      return this.datas && this.datas.length === 0
    },
    filterObj () {
      const json = {}
      if (this.name) {
        json['name'] = { $regex: this.name }
      }
      if (this.rangeValue && this.rangeValue.length > 0) {
        json['createdAt'] = {
          $gt: moment(this.rangeValue[0])
            .startOf('day')
            .toISOString(),
          $lte: moment(this.rangeValue[1])
            .endOf('day')
            .toISOString()
        }
      }
      if (!this.level) {
        json['hierarchy'] = {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.userLevelTag }
            },
            className: 'hierarchy'
          }
        }
      } else {
        json['hierarchy'] = {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.level }
            },
            className: 'hierarchy'
          }
        }
      }
      return json
    }
  },
  watch: {
    filterObj () {
      this.current = 1
      this.init()
    }
  },
  mounted () {
    if (this.userLevelTag) {
      this.level = this.userLevelTag
    }
    this.init()
  },
  methods: {
    jump (item) {
      this.$router.push({
        path: '/grainstore',
        query: { depot: item.objectId, hid: item.hierarchy }
      })
    },
    async handleAddOk () {
      this.confirmLoading = true
      await this.submit()
      this.showAdd = false
      this.confirmLoading = false
      this.reset()
    },
    handleAddCancel () {
      this.showAdd = false
    },
    addData () {
      this.formdata = {}
      this.showAdd = true
      this.confirmLoading = false
    },
    async submit () {
      const errors = await this.$refs.inputs.validate()
      if (!Object.keys(errors).length) {
        const { cityCode, provinceCode } = await getAddressAllAdcode(
          this.formdata.address
        )
        await this.$tkParse.post('/classes/grainWarehouse', {
          hierarchy: this.formdata.hierarchy,
          name: this.formdata.name,
          wheelMan: this.formdata.wheelMan,
          wheelManPhone: this.formdata.wheelManPhone,
          contacter: this.formdata.contacter,
          contacterPhone: this.formdata.contacterPhone,
          address: this.formdata.address,
          cityCode: cityCode,
          provinceCode: provinceCode,
          detailedAddress: this.formdata.detailedAddress,
          bugNum: 0
        })
        this.formdata = {}
      } else {
        throw new Error('input validate error')
      }
    },
    async init () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([
        this.queryListInfo(),
        this.queryInfoSum()
      ])
      this.datas = results[0]
      this.total = results[1]
      this.$loading.hide()
    },
    async reset () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([this.queryListInfo()])
      this.datas = results[0]
      this.$loading.hide()
    },
    async queryListInfo () {
      const res = await this.$tkParse.get('/classes/grainWarehouse', {
        params: {
          order: '-createdAt',
          where: this.filterObj,
          limit: this.pageSize,
          skip: (this.current - 1) * this.pageSize
        }
      })
      return res.data.results
    },
    async queryInfoSum () {
      const res = await this.$tkParse.get('/classes/grainWarehouse', {
        params: {
          where: this.filterObj,
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId'
        }
      })
      return res.data.results.length
    },
    async onChange () {
      this.$loading.show()
      this.datas = await this.queryListInfo()
      this.$loading.hide()
    },
    onShowSizeChange () {
      this.current = 1
      this.init()
    },
    onSearch (value) {
      if (!value) {
        this.searchOptions = this.datas
      } else {
        this.searchOptions = this.datas.filter(item =>
          item.name && item.name.toLowerCase().includes(value.toLowerCase())
        )
      }
    },
    onSelect (value) {
      const item = this.datas.find(item => item.objectId === value)
      if (item) {
        this.jump(item)
      }
    },
    onFocus () {
      if (!this.name) {
        this.searchOptions = this.datas
      }
    }
  }
}
</script>
<style>
.height-full {
  height: 100%;
}
</style>
